import React from 'react';
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import DatosEmpadronadorTSE from './datosEmpadronadorTSE'
import DatosDeIdentidad from './datosDeIdentidad'
import DatosDelDPI from './datosDelDPI'
import DatosDelCiudadano from './datosDelCiudadano'
import EstatusDelCiudadano from './estatusDelCiudadano'

function DatosCiudadanoTSE(props) {   
    return (

        <div>
            <DatosEmpadronadorTSE/>
            <DatosDeIdentidad {...props} />
            <DatosDelDPI />
            <DatosDelCiudadano />
            <EstatusDelCiudadano /> 
        </div>
    );
}


export default connect(mapStateToProps, mapDispatchToProps)(DatosCiudadanoTSE);